module.exports = "/images/Arrow-Big-right.png?c494a12ce2736baa0a91dd987ef6cbb7";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/Arrow-Big-right.png
// module id = I/sC
// module chunks = 1